module.exports = __webpack_public_path__ + "static/img/1.b747069.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.jpg
// module id = tGse
// module chunks = 0